<section class="pie-chart">   
    <section class="content-chart-pie">
        <canvas [attr.id]="idChart"></canvas>

        <section class="content-chart-legendas">
                <div>
                    <span class="legenda-chart legenda-participante"></span>
                    <span>Participante - {{valorParticipante | currency:'BRL'}}</span>
                </div>
                <div>
                    <span class="legenda-chart legenda-patrocinadora"></span>
                    <span>Patrocinadora - {{valorPatrocinadora | currency:'BRL'}}</span>
                </div>
                <div *ngIf="valorPortabilidade">
                    <span class="legenda-chart legenda-portabilidade"></span>
                    <span>Portabilidade - {{valorPortabilidade | currency:'BRL'}}</span>
                </div>
                <div>
                    <span class="legenda-chart legenda-rentabilidade"></span>
                    <span>Rentabilidade - {{valorRentabilidade | currency:'BRL'}}</span>
                </div>
        </section>
    </section>
</section>
